"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TEXT_COLORS = void 0;
const TEXT_COLORS = exports.TEXT_COLORS = Object.freeze({
  primary: 'primary',
  secondary: 'secondary',
  tertiary: 'tertiary',
  disabled: 'disabled',
  clickable: 'clickable',
  neutral: 'neutral',
  success: 'success',
  information: 'information',
  warning: 'warning',
  danger: 'danger',
  inversePrimary: 'inversePrimary',
  inverseSecondary: 'inverseSecondary',
  favorite: 'favorite'
});